import useRequest from '@/websdk/utils/request';
export default (function () {
  const { isRequestSuccessed, exec } = useRequest({
    url: '/api/Work/shop/position',
    name: 'locationInforPOST',
    method: 'POST',
  });
  return [isRequestSuccessed, exec];
});
